import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ShoppingCartManager from 'webshop/js/shopping-cart-manager';
import ProductQuestion from 'webshop/js/product-question';
import { calculateNotificationLocation } from 'webshop/js/product-helpers';
import 'webshop/js/facebook';
import 'masterslider';
import 'swipebox';

$(function() {
    ShoppingCartManager.ShoppingCartManager.setData(window.initial_cart_data);
    ReactDOM.render(React.createElement(ShoppingCartManager.NavShoppingCart), document.getElementById('nav-cart'));
    ReactDOM.render(React.createElement(ShoppingCartManager.ProductAddToCart, React.__spread({}, window.product_data)), document.getElementById('price-block'));
    var $questionElDesk = $('#product-question-desktop');
    var $questionElMobile = $('#product-question-mobile');

    if ($questionElDesk.length) {
        ReactDOM.render(React.createElement(ProductQuestion,
                                            {user: $questionElDesk.data('user'),
                                             product: $questionElDesk.data('product')
                                            }),
                     $questionElDesk.get(0));
    }
    if ($questionElMobile.length) {
        ReactDOM.render(React.createElement(ProductQuestion,
                                            {user: $questionElMobile.data('user'),
                                             product: $questionElMobile.data('product')
                                            }),
                     $questionElMobile.get(0));
    }
    var hashChanged = function(e) {
        if (document.location.hash != '#swipe' && $.swipebox.isOpen) {
            $.swipebox.close();
        }
    };

    $(window).on('hashchange', hashChanged);
    $('.master-slider').masterslider({
        loop: true,
        widht: 640,
        height: 320,
        view:'fadeBasic',
        layout:'partialview',
        mouse: false,
        controls: {
            arrows: {}
        },
        autoplay: true
    });
    $('.swipebox').swipebox({
        afterOpen: function(){
            document.location.hash = '#swipe';
        },
        afterClose: function(){
            if (window.history && document.location.hash == '#swipe') {
                window.history.back();
            }
        }
    });

    $(window).on("scroll", function(e) {
      if ($('.jGrowl-notification').length)
        calculateNotificationLocation();
    });
});



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/product.js
 **/